import React from "react"

import { useTheme } from "@mui/material/styles"
import Stack from "@mui/system/Stack"
import { Outlet } from "react-router-dom"

import { useAppDrawer } from "@hooks/useAppDrawer"

import { AppDrawer, appDrawerWidth } from "../AppDrawer"
import { TopNavigation, topNavigationHeight } from "../TopNavigation"

export const UnprotectedLayout: React.FC = () => {
  const { toggleDrawer, open } = useAppDrawer()
  const theme = useTheme()
  return (
    <Stack
      direction="column"
      position="fixed"
      top={0}
      left={0}
      overflow="auto"
      height={"100vh"}
      width={"100vw"}
    >
      <TopNavigation onToggleAppDrawer={toggleDrawer} />

      <Stack
        direction="row"
        sx={{
          pt: `${topNavigationHeight}px`,
        }}
      >
        <AppDrawer />
        <Stack
          direction="column"
          gap={theme.spacing(2)}
          sx={{
            ml: open ? `${appDrawerWidth}px` : 0,
            p: 2,
            width: open ? `calc(100% - ${appDrawerWidth}px)` : "100%",
          }}
        >
          <Outlet />
        </Stack>
      </Stack>
    </Stack>
  )
}
